module.exports = __webpack_public_path__ + "img/access_4_en.5ec6fd16.jpg";